// extracted by mini-css-extract-plugin
export default {"component":"Lmo6sc","body":"iH9FSM","side":"BwhyRY","fullHeight":"SXOwxb"};